var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraMuted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_3370)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_3370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.24 6.23996V15.82C1.24 16.57 1.85 17.17 2.59 17.17H13.69L1.72 5.20996C1.43 5.45996 1.24 5.82996 1.24 6.24996V6.23996Z",
    fill: "#14A4A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.29 5.98L15.56 8.53V6.25C15.56 5.5 14.95 4.9 14.21 4.9H6.05L2.16 1L1 2.16L3.73 4.89H3.72L15.36 16.53L19.21 20.38L20.37 19.22L15.56 14.41V13.55L20.29 16.1C20.53 16.23 20.83 16.05 20.83 15.78V6.3C20.83 6.02 20.53 5.85 20.29 5.98Z",
    fill: "#99999A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_3370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_3370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.83,
    height: 19.37,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMuted);
export default __webpack_public_path__ + "static/media/camera-muted.dea2ee0453c9b0de118f0e98db39e21e.svg";
export { ForwardRef as ReactComponent };